export default "__VITE_ASSET__DcpqVvko__"